<script>
import { deleteAddOn } from "../../../api/services/addon.service";
export default {
  props: {
    visible: Boolean,
    closeable: Boolean,
    extraID: String,
  },
  data() {
    return {
      extraId: null,
      isDeletingProcessing: false,
      isDeleteSuccess: false,
      isDeleteFailed: false,
      isFormSubmited: false,
    };
  },
  computed: {
    showModal: {
      get() {
        return this.visible;
      },
      set(value) {
        if (!value) {
          this.$emit("close");
        }
      },
    },
  },
  mounted() {
    this.extraId = this.extraID;
  },
  methods: {
    async clickDeleteExtra() {
      this.isFormSubmited = true;
      this.isDeletingProcessing = true;
      let deleteExtraSuccess = await deleteAddOn(this.extraId);

      if (deleteExtraSuccess) {
        this.isDeletingProcessing = false;
        this.isDeleteSuccess = true;
      } else if (!deleteExtraSuccess) {
        this.isDeletingProcessing = false;
        this.isDeleteFailed = true;
      }
    },
    clickCloseButton() {
      this.$emit("reload");
    },
  },
};
</script>

<template>
  <!-- Delete Dataset Model -->
  <b-modal
    v-model="showModal"
    centered
    hide-footer
    :title="this.$i18n.t('extras.deleteExtra.title')"
    no-close-on-backdrop
    no-close-on-esc
    header-close-content
  >
    <div class="row mt-3" v-if="!isFormSubmited">
      <div class="col-md-5 text-lg-center">
        <b-img
          class=""
          alt=""
          :src="require('@/assets/images/Delete Extra.png')"
          style="height: 150px"
        ></b-img>
      </div>
      <div class="col-md-7">
        <div class="d-flex mb-3">
          <p>
            {{ $t("extras.deleteExtra.question") }}
            <br />
            {{ $t("extras.deleteExtra.information") }}
          </p>
        </div>
        <div class="pb-2">
          <b-button variant="light" @click="showModal = false">{{
            $t("general.buttons.cancel")
          }}</b-button>
          <b-button variant="danger" @click="clickDeleteExtra" class="ml-2">{{
            $t("general.buttons.delete")
          }}</b-button>
        </div>
      </div>
    </div>
    <div class="row">
      <!-- Deleting Processing -->
      <div class="col-md-12 text-center" v-if="isDeletingProcessing">
        <b-spinner
          style="width: 5rem; height: 5rem"
          class="m-2"
          variant="warning"
          role="status"
        ></b-spinner>
        <h5 class="mt-3">
          {{ $t("extras.deleteExtra.deleteProcessingTitle") }}
        </h5>
        <p class="mt-3">
          {{ $t("extras.deleteExtra.deleteProcessingText") }}
        </p>
      </div>
      <!-- Delete Success -->
      <div class="col-md-12 text-center" v-if="isDeleteSuccess">
        <i class="bx bx-check-circle bx-tada text-success display-1"></i>
        <h5 class="mt-3">
          {{ $t("extras.deleteExtra.deleteSuccesTitle") }}
        </h5>
        <p class="mt-3 mb-3">
          {{ $t("extras.deleteExtra.deleteSuccessText") }}
        </p>
        <b-button variant="warning" @click="clickCloseButton()">
          <i class="bx bxs-x-circle mr-1"></i>
          {{ $t("general.buttons.close") }}</b-button
        >
      </div>
      <!-- Delete Failed -->
      <div class="col-md-12 text-center" v-if="isDeleteFailed">
        <i class="bx bx-x-circle bx-tada text-danger display-1"></i>
        <div class="mt-3">
          {{ $t("extras.deleteExtra.deleteFailedTitle") }}
        </div>
        <p class="mt-3">
          {{ $t("extras.deleteExtra.deleteFailedText") }}
        </p>
      </div>
    </div>
  </b-modal>
</template>